import ListReadings from '@/views/reports/readings/list-readings.vue'
import ListCheckIn from '@/views/checkin/list-checkin.vue'
import ListItems from '@/views/reports/sales/list-items.vue'
import ListHolders from '@/views/reports/list-holders.vue'
import EventRevenue from '@/views/reports/event-revenue/event-revenue.vue'
import ListInvoices from '@/views/reports/sales/list-invoices.vue'
import ListOrders from '@/views/reports/orders/list-orders.vue'
import ShowOrder from '@/views/reports/orders/show-order.vue'

export const routes = [
  {
    path: '/reports/readings',
    name: 'list-readings',
    component: ListReadings,
  },
  {
    path: '/check-in',
    name: 'list-checkin',
    component: ListCheckIn,
  },
  {
    path: '/reports/sales/list-items',
    name: 'list-items',
    component: ListItems,
  },
  {
    path: '/reports/holders',
    name: 'list-holders',
    component: ListHolders,
  },
  {
    path: '/reports/event-revenue/:event?',
    name: 'event-revenue-report',
    component: EventRevenue,
  },
  {
    path: '/reports/list-invoices',
    name: 'list-invoices',
    component: ListInvoices,
  },
  {
    path: '/reports/orders',
    name: 'list-orders',
    component: ListOrders,
  },
  {
    path: '/reports/orders/',
    name: 'list-orders',
    component: ListOrders,
  },
  {
    path: '/reports/orders/:id',
    name: 'show-order',
    component: ShowOrder,
  },
]
